import * as React from 'react';

const WrongInformationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={26} aria-label="Wrong information icon">
    <g data-name="Group 1700">
      <path
        data-name="Path 361"
        d="M.727 25.838h18.9a.722.722 0 00.727-.718V2.153a.723.723 0 00-.727-.718h-3.759A2.229 2.229 0 0013.759 0H6.606a2.259 2.259 0 00-2.114 1.435H.727A.723.723 0 000 2.153V25.12a.722.722 0 00.727.718zm5.278-23.2a.707.707 0 01-.186-.555.765.765 0 01.786-.645h7.153a.765.765 0 01.766.562.715.715 0 01-.148.61.73.73 0 01-.563.264H6.542a.722.722 0 01-.537-.238zm-4.551.236H4.49a2.158 2.158 0 00.439.731 2.2 2.2 0 001.614.7h7.271a2.184 2.184 0 001.687-.789 2.135 2.135 0 00.368-.646h3.034V24.4H1.454z"
        fill="#0a1514"
      />
      <text
        data-name="!"
        transform="translate(7 20)"
        fill="#0a1514"
        fontSize={20}
        fontFamily="Helvetica"
      >
        <span x={0} y={0}>
          !
        </span>
      </text>
    </g>
  </svg>
);

export default WrongInformationIcon;
